import {Pipe, PipeTransform} from '@angular/core';
import {map} from 'rxjs/operators';

@Pipe({
  name: 'limitto'
})
export class LimittoPipe implements PipeTransform {

  transform(value: any, args: string): any {
    if (value) {
      const tempData = Array.from(value);
      const limit = args ? parseInt(args, 10) : 10;
      if (tempData) {
        return tempData.length > limit ? tempData.splice(0, limit) : tempData;
      } else {
        return tempData;
      }
    } else {
      return value;
    }
  }
}

@Pipe({
  name: 'limittostart',
  pure: false
})
export class LimittostartPipe implements PipeTransform {
  transform(value: any, args: string, start: number): any {
    if (value) {
      const tempData = Array.from(value);
      const limit = args ? parseInt(args, 10) : 10;
      if (tempData && tempData.length > start) {
        return tempData.splice(start, limit);
      }
    } else {
      return value;
    }
  }
}
